const isProd = process.env.NODE_ENV === 'production';

export const devLog = (...args) => {
  if (!isProd) console.log(...args);
};

export const devWarn = (...args) => {
  if (!isProd) console.warn(...args);
};
